<template lang="html">
  <d-button-group class="buttons">
    <d-button size="sm" class="btn-info" @click.prevent="edit()">
      <i class="fas fa-pencil-alt"></i><span class="d-none d-lg-inline"> Editar</span>
    </d-button>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
      <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
    </d-button>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CommercialService from '_services/rest/modules/commercial';
import { _DELETE_COMMERCIAL_, _EDIT_COMMERCIAL_ } from '_modules/commercial/components/CommercialModel';

export default {
  name: 'commercial-buttons',
  props: {
    commercial: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    blockAccess() {
      const status = (this.commercial.status === 1) ? 0 : 1;
      CommercialService.toggleAccess(this.commercial.id, status)
        .then(() => {
          this.$router.push({ name: 'admin-commercial-list', params: { page: 1 } });
          Events.$emit('update:pagination', { page: 1 });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    edit() {
      this.setToggle({ type: 'edit_commercial_modal', bool: true });
      Events.$emit(_EDIT_COMMERCIAL_, this.commercial);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_COMMERCIAL_, this.commercial);
    },
  },
  mounted() {},
};
</script>
